import React from "react";
import { Link } from "react-router-dom";

import { Wrapper, Content, Image, Description } from "./Project.styles";

const Project = ({ img, project, position }) => (
  <Wrapper>
    <Content className={position}>
      <Image>
        <img src={`images/${project.image}`} alt={project.title} />
      </Image>
      <Description>
        <h3>{project.title}</h3>
        <p>{project.description}</p>
        <Link to={`/project/${project.title}`}>Read the case study</Link>
      </Description>
    </Content>
  </Wrapper>
);

export default Project;
